module.exports = __webpack_public_path__ + "loginBackground-min.33d2884.jpg";